import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@atlaskit/modal-dialog';

const getAppearance = (value) => {
  if (value === 'error') {
    return 'danger';
  } if (value === 'warning') {
    return 'warning';
  }

  return false;
};

const TypeModal = props => (
  <Modal
    {...props}
    appearance={getAppearance(props.appearance)}
    heading={props.title}
    onClose={props.onClose}
    actions={[
      ...props.actions,
      {
        text: 'Close',
        appearance: 'default',
        onClick: props.onClose,
      },
    ]}
  >
    {props.appearance ? (
      <div style={{ paddingLeft: 34 }}>
        {props.children}
      </div>
    ) : props.children}
  </Modal>
);

TypeModal.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  appearance: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  width: PropTypes.string,
};

TypeModal.defaultProps = {
  actions: [],
  appearance: '',
  children: '',
  title: 'Just a second!',
  width: 'small',
};

export default TypeModal;
